import UserProfilePermissions from './UserProfilePermissions'

export default UserProfilePermissions
